import { api } from '../config/api';

/**
 * Support Ticket Service - GVC Portal
 * Handles all support ticket operations through the proxy to SVT
 */

export const supportService = {
  // Submit a new ticket
  submitTicket: (data) => api.post('/api/support/tickets', data),

  // Get current user's tickets
  getTickets: (params = {}) => {
    const queryString = new URLSearchParams(params).toString();
    const endpoint = queryString ? `/api/support/tickets?${queryString}` : '/api/support/tickets';
    return api.get(endpoint);
  },

  // Get ticket details
  getTicket: (ticketNumber) => api.get(`/api/support/tickets/${ticketNumber}`),

  // Add comment to ticket
  addComment: (ticketNumber, comment) =>
    api.post(`/api/support/tickets/${ticketNumber}/comments`, { comment }),

  // Add attachment to ticket
  addAttachment: (ticketNumber, data) =>
    api.post(`/api/support/tickets/${ticketNumber}/attachments`, data)
};

// Status badge colors (dark theme)
export const STATUS_COLORS = {
  new: { bg: 'rgba(56, 189, 248, 0.15)', text: '#38bdf8', label: 'New' },
  open: { bg: 'rgba(212, 169, 78, 0.15)', text: '#D4A94E', label: 'Open' },
  in_progress: { bg: 'rgba(96, 165, 250, 0.15)', text: '#60a5fa', label: 'In Progress' },
  on_hold: { bg: 'rgba(192, 132, 252, 0.15)', text: '#c084fc', label: 'On Hold' },
  resolved: { bg: 'rgba(74, 222, 128, 0.15)', text: '#4ADE80', label: 'Resolved' },
  closed: { bg: 'rgba(160, 160, 160, 0.15)', text: '#A0A0A0', label: 'Closed' }
};

// Priority badge colors (dark theme)
export const PRIORITY_COLORS = {
  low: { bg: 'rgba(74, 222, 128, 0.15)', text: '#4ADE80', label: 'Low' },
  medium: { bg: 'rgba(212, 169, 78, 0.15)', text: '#D4A94E', label: 'Medium' },
  high: { bg: 'rgba(251, 146, 60, 0.15)', text: '#fb923c', label: 'High' },
  urgent: { bg: 'rgba(248, 113, 113, 0.15)', text: '#F87171', label: 'Urgent' }
};

// Category options
export const CATEGORIES = [
  { value: 'IT', label: 'IT Support' },
  { value: 'Website', label: 'Website Issues' },
  { value: 'Portal', label: 'Portal Problems' },
  { value: 'Hardware', label: 'Hardware Issues' },
  { value: 'Other', label: 'Other' }
];

// Priority options
export const PRIORITIES = [
  { value: 'low', label: 'Low - General questions, minor issues' },
  { value: 'medium', label: 'Medium - Standard issues, affects work' },
  { value: 'high', label: 'High - Urgent issues, blocking work' },
  { value: 'urgent', label: 'Urgent - Critical, system down' }
];

// Format time difference for display
export const formatTimeAgo = (dateString) => {
  if (!dateString) return 'N/A';

  const date = new Date(dateString);
  const now = new Date();
  const diffMs = now - date;
  const diffMins = Math.floor(diffMs / 60000);
  const diffHours = Math.floor(diffMs / 3600000);
  const diffDays = Math.floor(diffMs / 86400000);

  if (diffMins < 1) return 'Just now';
  if (diffMins < 60) return `${diffMins}m ago`;
  if (diffHours < 24) return `${diffHours}h ago`;
  if (diffDays < 7) return `${diffDays}d ago`;

  return date.toLocaleDateString();
};

// Format date for display
export const formatDate = (dateString) => {
  if (!dateString) return '-';
  return new Date(dateString).toLocaleString('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  });
};

export default supportService;
